module.exports = __webpack_public_path__ + "img/Our_Inn_Place@2x.e118a813.png";